export default __webpack_public_path__ + "static/media/emptyslip.af35e042.png";